import React, { useState, useEffect } from 'react';
import api from '../services/api';

const DataArchivePage = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = 'PayzoPay - Veri Arşivleme';
    }, []);

    const handleDownload = async () => {
        if (!window.confirm('60 günden eski veriler taranıp JSON formatında indirilecek. Onaylıyor musunuz?')) return;

        setLoading(true);
        try {
            const res = await api.getArchivedData();
            const data = res.data;

            const jsonString = JSON.stringify(data, null, 2);
            const blob = new Blob([jsonString], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = `payzopay_archive_60days_${new Date().toISOString().split('T')[0]}.json`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert(`Arşiv başarıyla indirildi.\n\nBulunan Kayıtlar:\nYatırımlar: ${data.counts.investments}\nÇekimler: ${data.counts.withdrawals}\nLoglar: ${data.counts.logs}\nAPI Logları: ${data.counts.apiLogs}`);
        } catch (error) {
            console.error(error);
            alert('Veri indirilemedi veya sunucu hatası.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', color: 'var(--text-color)' }}>
            <h2>Veri Arşivleme</h2>
            <div style={{ backgroundColor: 'var(--card-bg)', padding: '30px', borderRadius: '8px', boxShadow: 'var(--shadow)', maxWidth: '600px' }}>
                <div style={{ marginBottom: '20px', fontSize: '1.1em' }}>
                    <i className="fas fa-archive" style={{ marginRight: '10px', color: '#ffc107' }}></i>
                    60 Gün Üzeri Veri İndirme
                </div>
                <p style={{ lineHeight: '1.6', opacity: 0.8 }}>
                    Sistem performansını korumak veya yedekleme amacıyla, 60 günden daha eski olan Yatırım Talepleri, Çekim Talepleri, Teslimatlar, Kullanıcı Logları ve API Loglarını buradan JSON formatında indirebilirsiniz.
                </p>
                <div style={{ marginTop: '30px' }}>
                    <button
                        onClick={handleDownload}
                        disabled={loading}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontSize: '1em',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}
                    >
                        {loading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-download"></i>}
                        {loading ? 'Veriler Hazırlanıyor...' : 'Arşivi İndir'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DataArchivePage;